var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 76,
    viewBox: "0 0 83 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2476 16.4685L44.7225 26.6105C44.6353 26.634 44.5747 26.7132 44.5747 26.8035V75.5893C44.5747 75.721 44.6998 75.8168 44.8269 75.7824L82.352 65.6405C82.4392 65.6169 82.4998 65.5378 82.4998 65.4474V16.6616C82.4998 16.5299 82.3748 16.4342 82.2476 16.4685Z",
    fill: "#CACBCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7936 15.3577L2.17327 11.4745C1.98269 11.4159 1.98589 11.145 2.17779 11.0909L41.4433 0.0160068C41.4803 0.00555792 41.5196 0.0060212 41.5564 0.0173409L54.1767 3.90051C54.3673 3.95915 54.3641 4.23003 54.1722 4.28416L14.9067 15.359C14.8696 15.3695 14.8304 15.369 14.7936 15.3577Z",
    fill: "#CACBCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4419 23.5547L26.7488 18.657C26.5613 18.5944 26.5684 18.3268 26.759 18.2744L67.066 7.18995C67.1042 7.17944 67.1447 7.18052 67.1823 7.19305L81.8754 12.0908C82.0629 12.1533 82.0558 12.4209 81.8652 12.4733L41.5582 23.5578C41.52 23.5683 41.4795 23.5672 41.4419 23.5547Z",
    fill: "#CACBCB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 65.4474V16.6565C0.5 16.5264 0.622278 16.431 0.748507 16.4625L12.6485 19.4375C12.7376 19.4598 12.8 19.5398 12.8 19.6316V37.7746C12.8 37.8639 12.8592 37.9424 12.9451 37.9669L19.7201 39.9026C19.8479 39.9391 19.9751 39.8432 19.9751 39.7103V21.7885C19.9751 21.6563 20.1011 21.5604 20.2286 21.5958L38.2786 26.6097C38.3652 26.6338 38.4251 26.7126 38.4251 26.8024V75.5893C38.4251 75.721 38.3 75.8168 38.1729 75.7824L0.647818 65.6405C0.560588 65.6169 0.5 65.5378 0.5 65.4474Z",
    fill: "#CACBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProduct);
export default __webpack_public_path__ + "static/media/defaultProduct.8f8954455400927c5c47fa795d428f31.svg";
export { ForwardRef as ReactComponent };